export default __webpack_public_path__ + "static/media/q8.e20f8ccc.svg";